module.exports = __webpack_public_path__ + "static/media/epayco_pago_seguro.3a8ad73b.png";